import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../ui/Button";
import Loader from "../../ui/Loader";
import StyledButton from "../../ui/Button/styled";
import deleteProfessionAction from "../../../../state/actions/ProfessionActions/deleteProfessionAction";
import getIdSelector from "../../../../state/selectors/ClientSelectors/getIdSelector";
import getProfessionIdSelector from "../../../../state/selectors/ProfessionSelectors/getProfessionIdSelector";
import isEditingProfessionSelector from "../../../../state/selectors/ProfessionSelectors/isEditingProfessionSelector";
import isSendingProfessionSelector from "../../../../state/selectors/ProfessionSelectors/isSendingProfessionSelector";
import isUserAdministratorSelector from "../../../../state/selectors/ClientSelectors/isUserAdministratorSelector";
import styled from "styled-components";
import toggleEditingAction from "../../../../state/actions/ProfessionActions/toggleEditingAction";

const ToggleProfessionEditing: React.FC = () => {
    const isSending = useSelector((state: Store) => isSendingProfessionSelector(state));
    const isEditing = useSelector((state: Store) => isEditingProfessionSelector(state));
    const id = useSelector((state: Store) => getProfessionIdSelector(state));
    const dispatch = useDispatch();
    const toggleEditing = useCallback(() => dispatch(toggleEditingAction()), [dispatch]);
    const isUserLoggedIn = useSelector((state: Store) => getIdSelector(state));
    const isUserAdministrator = useSelector((state: Store) => isUserAdministratorSelector(state));
    const deleteProfession = useCallback(() => dispatch(deleteProfessionAction()), [dispatch]);
    if (!id) {
        return null;
    }
    return (
        <Wrapper>
            {isUserLoggedIn && isUserAdministrator ? (
                <MarginButton danger shadow uppercase onClick={() => deleteProfession()}>
                    Cancella
                </MarginButton>
            ) : null}
            {isEditing ? (
                <MarginButton primary shadow uppercase isLoading={isSending}>
                    Salva {isSending && <Loader light />}
                </MarginButton>
            ) : (
                <MarginButton primary shadow uppercase onClick={() => window.print()}>
                    Stampa
                </MarginButton>
            )}
            {isUserLoggedIn && isUserAdministrator ? (
                <Button
                    onClick={() => {
                        toggleEditing();
                    }}
                    primary={!isEditing}
                    light={isEditing}
                    shadow
                    uppercase
                >
                    {isEditing ? "Annulla" : "Modifica"}
                </Button>
            ) : null}
        </Wrapper>
    );
};

export default ToggleProfessionEditing;

const Wrapper = styled.div`
    text-align: right;
    padding-bottom: 1rem;
    position: sticky;
    top: 4.5rem;
    z-index: 1;
    padding: 1rem 3.475rem;
    @media print {
        display: none;
    }
`;

const MarginButton = styled(StyledButton as any)`
    margin-right: 1rem;
`;
